module.exports = __webpack_public_path__ + "static/media/beard-trim.5970bf12.jpg";